<template>
  <div class="tag-body"  :key="searchItemType">
    <div class="option-container">
      <div class="back-btn" @click="onGoback">
        <i class="cubeic-back"></i>
      </div>
      <search v-model="searchKey" show-action
              class="search-vant"
              @search="onBeginSearch"
              @cancel="onCancelSearch"
              autofocus></search>
    </div>

    <div v-if="showSearchList" :key="searchBoxIndex">
      <list v-model="searchLoading"
            :finished="searchLoadingFinished"
            finished-text="没有更多"
            @load="onLoadSearch"
      >
        <mix-item-list :data="searchDataList"></mix-item-list>
      </list>
    </div>
  </div>
</template>

<script>
  import {Search, List} from "vant"
  import MixItemList from "@/components/ugc_item/MixItemList";

  export default {
    name: "SearchPage",
    components: {
      MixItemList, Search, List
    },
    data() {
      return {
        showSearchList: false,
        searchKey: "",
        searchItemType: "",

        searchOffset: 0,
        searchDataList: [],
        searchBoxIndex: 0,
        searchLoading: false,
        searchLoadingFinished: false,

      }
    },
    mounted() {
      this.init()
    },
    activated() {
      this.init()
    },
    methods: {
      init() {
        if (this.$route.query.item_type && this.$route.query.item_type !== this.searchItemType) {
          this.searchItemType = this.$route.query.item_type
          this.searchKey = ""
          this.showSearchList = false

          this.initSearch()
        }
      },

      initSearch() {
        this.searchOffset = 0
        this.searchDataList = []
        this.searchLoadingFinished = false
        this.searchLoading = false
        this.searchBoxIndex += 1
      },

      onGoback() {
        this.$router.go(-1)
      },

      onLoadSearch() {
        if (!this.searchKey) {
          return
        }
        let params = {
          "type": this.searchItemType,
          "key": this.searchKey,
          "offset": this.searchOffset,
        }
        this.$store.dispatch("SearchItems", params).then((data) => {
          if (data.code === 0) {
            this.searchDataList.push(...data.data);
            this.searchOffset = data.extra.max_cursor
            if (!data.extra.has_more) {
              this.searchLoadingFinished = true
            }
          } else {
            this.createToast("请求错误", "error")
            this.searchLoadingFinished = true
          }
          this.searchLoading = false
        }, () => {
          this.createToast("系统错误", "error")
          this.searchLoadingFinished = true
          this.searchLoading = false
        })
      },

      createToast(text, type) {
        if (!type) {
          type = "text"
        }
        const toast = this.$createToast({
          time: 1500,
          txt: text,
          type: type,
        })
        toast.show()
      },

      onBeginSearch() {
        this.initSearch()
        this.showSearchList = true
      },

      onCancelSearch() {
        this.showSearchList = false
        this.onGoback()
      },
    },
    watch: {
      searchKey() {
        if (this.searchKey) {
          this.onBeginSearch()
        }
      }
    }
  }

</script>

<style scoped lang="scss">

  .option-container {
    background: white;
    display: flex;
    align-items: center;
    min-height: 30px;

    .search-vant {
      width: 100%;
    }

    .back-btn {
      color: #fc9153;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      padding: 0 10px;
    }
  }

</style>

